<template>
  <div class="">
    <b-button v-b-toggle.Reservations class="btn btn-lg btn-collapse">
      {{ $t("pages.Reservations") }}
      <i class="fa fa-angle-down" aria-hidden="true"></i>
    </b-button>
    <b-collapse id="Reservations">
      <div class="my-card">
        <div class="row">
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="reservationsView"
              v-model="usersPrivilegeReservations.reservationsView"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="reservationsView">{{
              $t("view")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="reservationsAdd"
              v-model="usersPrivilegeReservations.reservationsAdd"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="reservationsAdd">{{
              $t("add")
            }}</label>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "UsersPrivilegeReservations",
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["usersPrivilegeReservations"],
  methods: {},
};
</script>

<style scoped lang="scss"></style>
